import useSWR from "swr";

import { simpleFetcher } from "../fetcher";

const url = "/api/v2/sp/onboarding-state";

interface SpOnboardingState {
  clientId: string;
  tenantId: string | null;
  siteId: string | null;
  driveId: string | null;
  permissionId: string | null;
  onboardingCompleted: boolean;
  hasSpAccessToken: boolean;
}

export function useSpOnboardingState() {
  return useSWR<SpOnboardingState, Error>(url, simpleFetcher);
}
